
import { CognitoUserPool, ICognitoUserPoolData } from "amazon-cognito-identity-js";

const poolData: ICognitoUserPoolData ={
    UserPoolId: ""+process.env.REACT_APP_UserPoolId,
    ClientId: ""+process.env.REACT_APP_ClientId
}

const UserPool: CognitoUserPool = new CognitoUserPool(poolData)
export default UserPool